import React from 'react';
import { Hero } from './components/Hero';
import { AppShowcase } from './components/AppShowcase';
import { About } from './components/About';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-forest" data-id="element-0">
      <Hero data-id="element-1" />
      <AppShowcase data-id="element-2" />
      <About data-id="element-3" />
      <Footer data-id="element-4" />
    </div>;
}